module.exports = __webpack_public_path__ + "img/jk2.d7acb51a.jpg";